export function sendAnalytics(
  eventName: string,
  data: {eventCategory?: string; eventLabel?: string} = {},
) {
  if (!window.gtag) return

  window.gtag('event', eventName, {
    ...(data.eventCategory && {event_category: data.eventCategory}),
    ...(data.eventLabel && {event_label: data.eventLabel}),
  })
}
